import DotBrush from './brushes/DotBrush'
import RoundBrush from './brushes/RoundBrush'
import { Gesture, Brush, BeadsBrush} from './brushes/BrushStroke'
import MathTool from './math/MathTool'
import EasingTool from './math/EasingTool'
import ColorTool from './colors/ColorTool'
import GeomTool from './geom/GeomTool.js'
import DrawTool from './draw/DrawTool.js'
import TextureTool from './texture/TextureTool.js'
import ObjectTool from './object/ObjectTool.js'
import GenArt from './GenArt.js'
import MosaicCircle from './geom/MosaicCircle.js'
import SVGToGcode from './convert/SVGToGcode.js'
import LocalFileApi from './file/LocalFileApi.js'
import FieldTool from './fields/FieldTool.js'
import TextTool from './text/TextTool.js'
import ArrayTool from './array/ArrayTool'
import * as shapes from './shapes/Shapes'
import * as materials from './materials/Materials'
import * as physics from './physics/PhysicsTool'

import HairyTexture from './texture/HairyTexture'

exports.GenArt = GenArt;
exports.brushes = {DotBrush, RoundBrush, Gesture, Brush, BeadsBrush};


exports.math = MathTool;
exports.easing = EasingTool;
exports.color = ColorTool;
exports.geom = GeomTool;
exports.shapes = shapes;
exports.materials = materials;
exports.draw = DrawTool;
exports.texture = TextureTool;
exports.object = ObjectTool;
exports.text = TextTool;
exports.MosaicCircle = MosaicCircle;
exports.SVGToGcode = SVGToGcode;
exports.LocalFileApi = LocalFileApi; 
exports.field = {FieldTool}; 
exports.physics = physics; 
exports.array = ArrayTool;

exports.textures = {HairyTexture};